import React from 'react';

import { TabItem, Tabs } from 'flowbite-react';

import BankStatementCollection from './BankStatementCollection';

const createBankStatementCollectionTabName = (
  bankStatementCollection,
  index
) => {
  let name = '';

  if (bankStatementCollection.bankName) {
    name = `${bankStatementCollection.bankName}`;

    if (bankStatementCollection.accountNumber) {
      name += ` - ${bankStatementCollection.accountNumber.slice(-4)}`;
    }
  } else {
    name = `Bank Statement Collection ${index + 1}`;
  }

  return name;
};

export default function BankStatementCollections({
  bankStatementCollections,
  refetch,
  loanFile,
}) {
  return (
    <div className="pb-10">
      <div className="h-full">
        <section className="bg-white dark:bg-gray-900">
          <div className="pt-8 px-4 md:px-12 mx-auto max-w-screen-xl lg:pt-16">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-6 gap-2">
              <h2 className="text-xl font-bold text-gray-900 dark:text-white">
                Bank Statement Collections
              </h2>
            </div>
            <Tabs>
              {bankStatementCollections?.map((collection, index) => {
                return (
                  <TabItem
                    key={collection.id}
                    title={createBankStatementCollectionTabName(
                      collection,
                      index
                    )}
                  >
                    <BankStatementCollection
                      bankStatementCollection={collection}
                      refetch={refetch}
                      loanFile={loanFile}
                    />
                  </TabItem>
                );
              })}
            </Tabs>
          </div>
        </section>
      </div>
    </div>
  );
}
